type ReoccurrenceType = {
	uuid: string;
	label: string;
	value: string;
};

export const reoccurrenceTypes: ReoccurrenceType[] = [
	{
		uuid: "a07d9b29-0f69-4bb4-8dd7-ab1864eededd",
		label: "Once",
		value: "ONCE",
	},
	{
		uuid: "a07d9b29-0f71-4a60-8361-ce3aedaa3e27",
		label: "Daily",
		value: "DAILY",
	},
	{
		uuid: "a07d9b29-0f73-45a7-b6a7-9b01aa91ba5a",
		label: "Weekly",
		value: "WEEKLY",
	},
	{
		uuid: "a07d9b29-0f75-4d02-a2a3-a199961860f7",
		label: "Monthly",
		value: "MONTHLY",
	},
];
